import axios from "axios";
import { logout } from "./auth";
import globalVar from "../util/global"


export const AccessClient = axios.create({
  headers: {
    //baseURL: process.env.SERVER,
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


// ----------------------------------------------------------------
//  Refresh Token으로 Access Token을 재요청하기
//    참고 : https://maruzzing.github.io/study/rnative/axios-interceptors%EB%A1%9C-%ED%86%A0%ED%81%B0-%EB%A6%AC%ED%94%84%EB%A0%88%EC%8B%9C-%ED%95%98%EA%B8%B0/
// ----------------------------------------------------------------
AccessClient.interceptors.request.use(
  (config) => {
    const csrfToken = globalVar.csrfToken;
    //console.log("csrfToken : ", csrfToken)
    if (csrfToken) {
      config.headers["biggame-csrf-token"] = csrfToken;
      //console.log("biggame-csrf-token : ", config.headers["biggame-csrf-token"])
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

AccessClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const {
      config,
      response: { status },
    } = error;
    const originalRequest = config;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // 리프레쉬 토큰으로 새로이 토큰 발행을 요청합니다.
      try {
        const {
          data: { result },
        } = await axios.post("/api/refresh-token");

        // 실패한 요청을 다시 요청합니다.
        if (result) {
          return axios(originalRequest);
        } else {
          await logout();
        }
      } catch (e) {
        //console.log(e);
        await logout();
      }
    }
    return Promise.reject(error);
  }
);
